import {EnvEventPostDataTransferObject} from "../../data-transfer-object/env/EnvEventPostDataTransferObject"
import {EnvEventValueObject} from "../../value-object/env/EnvEventValueObject"
import {StatePair, useStatePair} from "react-type-extension"
import {DateFormat} from "ts-format-extension"
import {unwrapUndefinedDate, unwrapUndefinedString} from "ts-type-extension"

export type EnvEventPostState = {
    title: StatePair<string>
    url: StatePair<string>
    toDataTransferObject(): EnvEventPostDataTransferObject
    fromValueObject(vo: EnvEventValueObject): void
    values(): [string, string]
}

export function useEnvEventPostState(): EnvEventPostState {
    return {
        title: useStatePair<string>(''),
        url: useStatePair<string>(''),
        toDataTransferObject(): EnvEventPostDataTransferObject {
            return {
                title: this.title.value,
                url: this.url.value,
            }
        },
        fromValueObject(vo: EnvEventValueObject) {
            this.title.setter(vo.title)
            this.url.setter(vo.url)
        },
        values(): [string, string] {
            return [
                this.title.value,
                this.url.value,
            ]
        }
    }
}
